import { render, staticRenderFns } from "./tdynamic.vue?vue&type=template&id=5b61c7e6&scoped=true"
import script from "./tdynamic.vue?vue&type=script&lang=js"
export * from "./tdynamic.vue?vue&type=script&lang=js"
import style0 from "./tdynamic.vue?vue&type=style&index=0&id=5b61c7e6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b61c7e6",
  null
  
)

export default component.exports